import { DeploymentBusinessUnitItemSchema } from "./deployment-business-unit-item";
import { DeploymentAccountItemSchema } from "./deployment-account-item";
import { DeploymentFuelBrandItemSchema } from "./deployment-fuel-brand-item";
import { DeploymentCashRegisterItemSchema } from "./deployment-cash-register-item";
import { DeploymentCountryItemSchema } from "./deployment-country-item";
import { DeploymentVendorItemSchema } from "./deployment-vendor-item";
import { ProductItemSchema } from "../product/product-item";
import { z } from "zod";

export const DeploymentDataSchema = z.object({
  Accounts: DeploymentAccountItemSchema.array(),
  BusinessUnits: DeploymentBusinessUnitItemSchema.array(),
  SubstituteProducts: ProductItemSchema.array(),
  RequiredProducts: ProductItemSchema.pick({
    Id: true,
    Name: true,
    ThumbnailUrl: true,
  }).array(),
  FuelBrands: DeploymentFuelBrandItemSchema.array(),
  CashRegisters: DeploymentCashRegisterItemSchema.array(),
  Countries: DeploymentCountryItemSchema.array(),
  Vendors: DeploymentVendorItemSchema.array(),
  Product: z.object({
    IsCanceled: z.boolean().optional(),
    IsInstalled: z.boolean().optional(),
    IsNotInstalled: z.boolean().optional(),
    Id: ProductItemSchema.shape.Id,
    Name: ProductItemSchema.shape.Name,
    ProductNumber: ProductItemSchema.shape.Number,
    ThumbnailUrl: ProductItemSchema.shape.ThumbnailUrl,
    PurchasedProductId: z.string().uuid().optional(),
  }),
});

export type DeploymentDataType = z.infer<typeof DeploymentDataSchema>;
